import React from 'react';
import Icon from '../../../components/AppIcon';

const DeleteTrabajoModal = ({ isOpen, trabajo, onClose, onDelete, onCancel }) => {
  if (!isOpen || !trabajo) return null;

  const piezas = trabajo?.piezas || [];
  const activePiezas = piezas?.filter(p => p?.estado === 'EN_PROCESO' || p?.estado === 'COMPLETADA');
  const hasProduccion = activePiezas?.length > 0;

  const clienteNombre = trabajo?.cliente?.nombre || 'Sin cliente';
  const productoNombre = trabajo?.producto?.nombre || 'Sin producto';
  const total = trabajo?.cantidad_piezas || piezas?.length || 1;
  const color = trabajo?.clienteColor || '#6B7280';

  const fechaLabel = trabajo?.fecha
    ? new Date(trabajo?.fecha + 'T12:00:00')?.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' })
    : 'Sin fecha';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(0,0,0,0.8)' }}>
      <div className="w-full max-w-md rounded-2xl border border-white/10 overflow-hidden" style={{ background: '#111111' }}>
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/8">
          <h2 className="font-oranienbaum font-bold text-white text-xl">
            {hasProduccion ? 'Cancelar Trabajo' : 'Eliminar Trabajo'}
          </h2>
          <button onClick={onClose} className="text-white/40 hover:text-white/70 transition-colors">
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-5 space-y-4">
          {/* Trabajo info */}
          <div className="p-4 rounded-xl border border-white/8" style={{ background: '#0A0A0A' }}>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-3 h-3 rounded-full" style={{ background: color }} />
              <span className="font-oranienbaum font-bold text-white">{clienteNombre}</span>
            </div>
            <div className="text-white/60 text-sm font-oranienbaum">{productoNombre}</div>
            <div className="text-white/40 text-xs font-oranienbaum mt-1 capitalize">{fechaLabel}</div>
            <div className="text-white/40 text-xs font-oranienbaum">{total} {total === 1 ? 'pieza' : 'piezas'}</div>
          </div>

          {hasProduccion ? (
            /* Has production — can only cancel */
            <div className="space-y-3">
              <div className="p-3 rounded-xl bg-amber-500/10 border border-amber-500/20">
                <div className="flex items-start gap-2">
                  <Icon name="AlertTriangle" size={16} className="text-amber-400 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-amber-400 text-sm font-oranienbaum font-semibold">Este trabajo ya tiene producción asociada</p>
                    <p className="text-amber-400/70 text-xs font-oranienbaum mt-0.5">
                      {activePiezas?.length} {activePiezas?.length === 1 ? 'pieza está' : 'piezas están'} en proceso o completadas. No se puede eliminar.
                    </p>
                  </div>
                </div>
              </div>
              <p className="text-white/50 text-sm font-oranienbaum">
                Puedes cancelar el trabajo para marcarlo como cancelado sin borrar los datos de producción.
              </p>
            </div>
          ) : (
            /* No production — can delete */
            <div className="p-3 rounded-xl bg-red-500/10 border border-red-500/20">
              <div className="flex items-start gap-2">
                <Icon name="Trash2" size={16} className="text-red-400 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-red-400 text-sm font-oranienbaum font-semibold">¿Eliminar este trabajo planificado?</p>
                  <p className="text-red-400/70 text-xs font-oranienbaum mt-0.5">
                    Se eliminarán el trabajo y sus {total} {total === 1 ? 'pieza' : 'piezas'}. Esta acción no se puede deshacer.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex gap-3 px-5 py-4 border-t border-white/8">
          <button
            onClick={onClose}
            className="flex-1 py-3 rounded-xl border border-white/10 text-white/60 font-oranienbaum hover:bg-white/5 transition-colors"
          >
            Cerrar
          </button>
          {hasProduccion ? (
            <button
              onClick={() => onCancel?.(trabajo)}
              className="flex-2 px-6 py-3 rounded-xl font-oranienbaum font-bold text-white bg-amber-600/80 hover:bg-amber-600 transition-colors"
              style={{ flexGrow: 2 }}
            >
              Cancelar Trabajo
            </button>
          ) : (
            <button
              onClick={() => onDelete?.(trabajo)}
              className="flex-2 px-6 py-3 rounded-xl font-oranienbaum font-bold text-white bg-red-600/80 hover:bg-red-600 transition-colors"
              style={{ flexGrow: 2 }}
            >
              Eliminar Trabajo
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteTrabajoModal;
